import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

interface Props {
  children: React.ReactElement;
  requiredRole?: string;
}

const ProtectedRoute: React.FC<Props> = ({ children, requiredRole }) => {
  const { token, user, loading } = useAuth();

  if (loading) return null;

  if (!token || !user) return <Navigate to="/login" replace />;

  const normalizedRole = user.roleName?.toLowerCase?.() || "";
  const required = requiredRole?.toLowerCase?.() || "";

  if (requiredRole && normalizedRole !== required) {
    if (normalizedRole === "mentor") return <Navigate to="/mentor-dashboard" replace />;
    if (normalizedRole === "admin") return <Navigate to="/admin-dashboard" replace />;
    if (normalizedRole === "jury") return <Navigate to="/jury-dashboard" replace />;
    return <Navigate to="/user-dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
